import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import TextField from '~/TextField/TextField.component';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Link } from '@mui/material';
import {
  StyleFielderButtonOutlined,
  StyleFielderTitleTypography
} from '~/FielderElements/FielderElements.styles';

const TaskCaseNumber = ({ createClicked, caseNumberValue }, ref) => {
  const lan = useLanguage();
  const [caseNumber, setCaseNumber] = useState(caseNumberValue ? caseNumberValue : '');
  const [showNumberTask, setShowNumberTask] = useState(false);
  useImperativeHandle(ref, () => caseNumber, [caseNumber]);
  const handleChange = (event) => {
    setCaseNumber(event.target.value);
  };
  const handleClose = () => setShowNumberTask(false);
  const handleShow = () => setShowNumberTask(true);
  return (
    <>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
        <Link
          component="button"
          underline="always"
          onClick={handleShow}
        >
          {lan.moreInformation}
        </Link>
      </Box>
      <Dialog
        aria-labelledby="task-number-dialog-title"
        open={showNumberTask}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="task-number-dialog-title">
          <StyleFielderTitleTypography variant={'subtitle2'}>
            {lan.enterCaseNumber}
          </StyleFielderTitleTypography>
        </DialogTitle>
        <DialogContent dividers className="text-center">
          <Box sx={{ mt: 1 }}>
            <TextField
              id="txt-task-caseNumber"
              value={caseNumber}
              variant="outlined"
              label={`${lan.caseNumber} (${lan.optional})`}
              onChange={handleChange}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions className="modal-footer-custom">
          <StyleFielderButtonOutlined
            onClick={handleClose}
            size={"medium"}
          >
            {lan.close || 'Close'}
          </StyleFielderButtonOutlined>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default forwardRef(TaskCaseNumber);
